(function ($) {

	var notesAndCoinImages = $('.js-image-popup');
	var imageOverlay = $('.js-image-popup-overlay');
	var imageOverlayWrapper = imageOverlay.find('.wrapper');

	notesAndCoinImages.each(function (i, ele) {
		var img = $(ele).find('img, .video').first().clone();
		var toggleBtn = $(ele).find('.js-image-popup-toggle');
		var closeBtn = $(ele).find('.js-popover-close');
		var innerHeight = $(window).height(); 

		toggleBtn.on('click',
			function () {
				imageOverlay.hide();
				imageOverlay.removeClass('open');
				imageOverlayWrapper.append(img);
				imageOverlayWrapper.append(closeBtn);
				imageOverlay.css('height', (innerHeight));
				imageOverlay.addClass('open');
				imageOverlay.show();

				imageOverlay.on('keyup', function (e) {
					if (e.which === 9) {
						closeBtn.focus();
					}
				});

			});
	});

	imageOverlay.after().click(function () {
		imageOverlay.hide();
		imageOverlayWrapper.empty();
	});

})(jQuery);
